import React from "react"
import style from "./index.module.less"
import BaseBox from "../BaseBox"

const SmallProduct = ({products}) => {
  
  return (
    <div className={style.smallProduct}>
      {products.map((item, index) => {
        return (
          <BaseBox intro={item} key={`sp${item.devName}-${index}`} />
        )
      })}
    </div>
  )
}

export default SmallProduct
